import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MaterialSelect from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const styles = theme => ({
  input: {
    marginTop: '5px'
  },
  root: {
    marginTop: '5px'
  },
  formControl: {
    width: '100%',
    marginBottom: '20px'
  },
  inputLabel: {
    transform: 'translate(12px, 12px) scale(0.75) !important'
  },
  halfControl: {
    width: '168px',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  }
});

class Select extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    options: PropTypes.array,
    id: PropTypes.string,
    classes: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    dataTestId: PropTypes.string
  };

  render() {
    const {
      label,
      value,
      onChange,
      options,
      id,
      classes,
      disabled,
      fullWidth,
      dataTestId
    } = this.props;

    const {
      formControl,
      inputLabel,
      input,
      halfControl,
      ...muiSelectClass
    } = classes;

    return (
      <FormControl className={fullWidth ? formControl : halfControl}>
        <InputLabel className={inputLabel} htmlFor={id}>
          {label}
        </InputLabel>
        <MaterialSelect
          native
          data-testid={dataTestId}
          classes={muiSelectClass}
          value={value}
          onChange={onChange}
          disabled={disabled}
          variant="outlined"
          input={<OutlinedInput id={id} />}
        >
          {options.map((option, index) => (
            <option disabled={option.disabled} key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </MaterialSelect>
      </FormControl>
    );
  }
}

export default withStyles(styles)(Select);
